import SearchResultPageView from 'src/pages/SearchPage/SearchResultPage/view'

import {
  searchSubmitQueryOption,
  useInfiniteScrollQuery,
} from 'src/hooks/react-query/useCustomInfiniteQuery.hook'
import { ResponseDataType, SearchSpace } from 'src/types/api'
import { Dispatch, SetStateAction, useCallback } from 'react'
import usePageNav from 'src/hooks/usePageNav.hook'
import useParamsType from 'src/hooks/useParamsType.hook'

export interface SearchIsResultProps {
  searchResultList: SearchSpace.CouponSearchType[] | any[]
  setTarget: Dispatch<SetStateAction<HTMLDivElement | null | undefined>>
  alwaysCouponDetailPageNav: (couponNumber: string, couponIdx: number) => void
  searchResultNoMore: boolean
  isSearchResultSuccess?: boolean
}
export interface SearchRecommendBrandProps {
  RecommendBrandList?: SearchSpace.RecommendBrandType[]
}
export interface SearchResultPageProps extends SearchIsResultProps, SearchRecommendBrandProps {}

const SearchResultPage = () => {
  const { search_word } = useParamsType()
  const { alwaysCouponDetailPageNav } = usePageNav()
  const {
    data: searchResultData,
    setTarget,
    isSuccess: isSearchResultSuccess,
  } = useInfiniteScrollQuery<SearchSpace.Request, SearchSpace.Response>(
    searchSubmitQueryOption(search_word!),
  )

  const searchResultListProcessData = useCallback(() => {
    let result: SearchSpace.CouponSearchType[] | any[] = []

    // eslint-disable-next-line array-callback-return
    searchResultData?.pages?.map((element: ResponseDataType<SearchSpace.Response>) => {
      !!element?.Body?.CouponSearch && result.push(...element?.Body?.CouponSearch)
    })

    return {
      result,
      noMore: !searchResultData?.pages?.at(-1)?.Body?.CouponSearch?.length,
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchResultData])

  const props: SearchResultPageProps = {
    searchResultList: searchResultListProcessData().result,
    searchResultNoMore: searchResultListProcessData().noMore,
    RecommendBrandList: searchResultData?.pages?.at(0)?.Body?.RecommendBrand,
    setTarget,
    alwaysCouponDetailPageNav,
    isSearchResultSuccess,
  }

  return <SearchResultPageView {...props} />
}
export default SearchResultPage
